module.exports = __webpack_public_path__ + "static/media/bg-main.4cc57866.jpg";